type LogArgs = unknown[];

function isDebugEnabled(): boolean {
  if (typeof window === 'undefined') return false;
  const flag = window.localStorage.getItem('wt_debug');
  if (flag === '0' || flag === 'false') return false;
  return true;
}

export const log = {
  debug: (...args: LogArgs) => {
    if (isDebugEnabled()) {
      console.log(...args);
    }
  },
  info: (...args: LogArgs) => {
    if (isDebugEnabled()) {
      console.log(...args);
    }
  },
  warn: (...args: LogArgs) => {
    console.warn(...args);
  },
  error: (...args: LogArgs) => {
    console.error(...args);
  },
};
